/* eslint-disable max-lines-per-function */
import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { formatHourDecimalToTimeString } from '@/domain/dienstplan/features/VisualEditor/utils/timeHelper/formatHourDecimalToTimeString';
import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';
import { toast } from '@/hooks/use-toast';

export function endBelegungResize({ ctx }: { ctx: SharedContext }) {
  const {
    belegungen,
    store: {
      removeBelegungById,
      setStartBelegungPosition,
      setIsResizingStart,
      setIsResizingEnde,
      updateBelegungById,
      setPopoverPosition,
      setIsPopoverOpen,
      setHoveredBelegung,
    },
    deleteBelegung,
  } = ctx;

  const activeBelegung = belegungen.find((b) => b.mode === 'resize');
  if (!activeBelegung) return;

  const newActiveInterval = new BelegungsIntervall(
    activeBelegung.belegung,
    'inactive',
  );

  updateBelegungById(newActiveInterval, newActiveInterval.belegung.id);

  if (
    activeBelegung.belegung.start === activeBelegung.belegung.ende ||
    activeBelegung.belegung.personenanzahlMax === 0
  ) {
    deleteBelegung({ belegungId: activeBelegung.belegung.id }).then(() => {
      removeBelegungById(activeBelegung.belegung.id);
      setStartBelegungPosition(undefined);
      setIsResizingStart(false);
      setIsResizingEnde(false);
      setPopoverPosition(undefined);
      setHoveredBelegung(undefined);
      setIsPopoverOpen(false);
    });
  } else {
    setStartBelegungPosition(undefined);
    setIsResizingStart(false);
    setIsResizingEnde(false);
    setPopoverPosition(undefined);
    setHoveredBelegung(undefined);
    setIsPopoverOpen(false);
    ctx
      .updateBelegung({
        input: {
          anzahlMitarbeiter: activeBelegung.belegung.personenanzahlMax,
          dauer: activeBelegung.width * 60,
          von: formatHourDecimalToTimeString(activeBelegung.belegung.start, 0),
          id: activeBelegung.belegung.id,
        },
      })
      .then(() => {
        toast({
          title: ctx.t(
            'domain.dienstplan.mindestbelegung.visualEditor.updateSuccess',
          ),
        });
      });
  }
}
